// Import Vitality groups
import VGDmp from '@/utils/classes/VitalityCategory/dmp';
import VGGembaWalks from '@/utils/classes/VitalityCategory/gw';
import VGProblems from '@/utils/classes/VitalityCategory/problems';

/**
 * An object that contains an array of VitalityCriterion.
 * Each VitalityCategory (just like VitalityCriterion) has a weight attr to weight the average
 *    of all VitalityCategory objects displayed in the VitalityHub page
 *
 * As of 2021, there are 3 categories of criteria for each main section of Shizen.
 * - Daily management of performance
 * - Problem Solving
 * - Gemba Walks
 */
export function VitalityCategory() {}

VitalityCategory.dmp = VGDmp;
VitalityCategory.problems = VGProblems;
VitalityCategory.gembaWalks = VGGembaWalks;

// Not a real category, used for sorting the main vitality table
VitalityCategory.vitality = {
  key: 'vitality',
  titleTr: 'VH_WHAT_TEAMS',
}

VitalityCategory.all = [
  VitalityCategory.dmp,
  VitalityCategory.problems,
  VitalityCategory.gembaWalks,
];

VitalityCategory.detailedAll = [...VitalityCategory.all];

// Generic attrs
Object.keys(VitalityCategory).forEach((key) => {
  const cat = VitalityCategory[key];
  cat.scoresKey = `${cat.key}Scores`;
});

export default {
  VitalityCategory,
};
